module.exports = __webpack_public_path__ + "static/flux-sketch-3-4545cd9ba24369e8bfc51b8a75cfe04c.jpg";